import {
  Hammer, Zap, Droplet, Sofa, Paintbrush, Thermometer, Trees,
  Sparkles, MoreHorizontal, Wrench,
} from "lucide-react";
import { ALL_CITIES, getDistricts } from "@/lib/turkeyData";

const MAP = {
  Hammer, Zap, Droplet, Sofa, Paintbrush, Thermometer, Trees, Sparkles, MoreHorizontal, Wrench,
};

export function CatIcon({ name, className }) {
  const Icon = MAP[name] || Wrench;
  return <Icon className={className} />;
}

export const CITIES = ALL_CITIES;

export function districtsFor(city) {
  const d = getDistricts(city);
  return d.length ? d : ["Merkez"];
}

export const MATERIAL_OPTIONS = [
  { value: "dahil", label: "Malzeme dahil" },
  { value: "dahil değil", label: "Malzeme dahil değil" },
  { value: "görüşülecek", label: "Görüşülecek" },
];

export const STATUS_LABELS = {
  active: "Aktif",
  negotiating: "Görüşülüyor",
  assigned: "Usta Seçildi",
  completed: "Tamamlandı",
  cancelled: "İptal",
};

export function timeAgo(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  const diff = (Date.now() - d.getTime()) / 1000;
  if (diff < 3600) return `${Math.max(1, Math.floor(diff / 60))} dk önce`;
  if (diff < 86400) return `${Math.floor(diff / 3600)} saat önce`;
  const days = Math.floor(diff / 86400);
  if (days < 30) return `${days} gün önce`;
  return d.toLocaleDateString("tr-TR");
}
